// src/pages/Legal/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => (
  <section id="privacy">
    <h2>Privacy Policy</h2>
    <p>Effective Date: March 11, 2025</p>
    <h4>Introduction</h4>
    <p>
      This Privacy Policy explains how Clascity, Inc (“we”, “us”, or “our”) collects, uses, and protects your personal information when you use the Ques platform.
      By using the Service, you consent to the practices described in this policy.
    </p>
    <h4>Information We Collect</h4>
    <ul>
      <li><strong>Personal Information:</strong> When you register an account, we may collect your name, email address, and other contact details.</li>
      <li><strong>Professional Information:</strong> If you are a professional, additional information such as your biography, expertise, and professional credentials may be collected.</li>
      <li><strong>Payment Information:</strong> Payment details (e.g., credit card information) are collected solely through Stripe, our third-party payment processor.</li>
      <li><strong>Usage Data:</strong> We collect information about your interaction with the Service, including IP address, browser type, and pages visited.</li>
    </ul>
    <h4>How We Use Your Information</h4>
    <ul>
      <li>Account Management: To create and manage your user account.</li>
      <li>Service Delivery: To facilitate Q&A interactions and payment processing.</li>
      <li>Communication: To send you updates, notifications, and other information related to the Service.</li>
      <li>Improvement: To analyze usage patterns and improve our Service.</li>
    </ul>
    <h4>Sharing and Disclosure</h4>
    <ul>
      <li><strong>Third-Party Service Providers:</strong> We share your information with trusted third parties, including Stripe, solely for the purpose of processing payments. See Stripe’s <a href="https://stripe.com/privacy">Privacy Policy</a>.</li>
      <li><strong>Legal Requirements:</strong> We may disclose your information if required by law or to protect our rights.</li>
      <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
    </ul>
    <h4>Data Security</h4>
    <p>We implement appropriate security measures to protect your personal information. However, no data transmission over the internet is completely secure. We cannot guarantee the absolute security of your data.</p>
    <h4>Cookies and Tracking Technologies</h4>
    <p>
      We use cookies and similar technologies to enhance user experience and gather information about usage. You may adjust your browser settings to refuse cookies; however, this may affect the functionality of the Service.
    </p>
    <h4>Your Rights</h4>
    <p>You have the right to access, update, or delete your personal information. To exercise these rights, please contact us at the email provided below.</p>
    <h4>International Data Transfers</h4>
    <p>
      Your information may be transferred and maintained on servers located outside your country of residence. We ensure that such transfers comply with applicable data protection laws.
    </p>
    <h4>Children’s Privacy</h4>
    <p>The Service is not intended for individuals under the age of 13. We do not knowingly collect personal information from children under 13.</p>
    <h4>Changes to This Privacy Policy</h4>
    <p>
      We may update this Privacy Policy periodically. We will notify you of any significant changes by posting the new policy on this page. Continued use of the Service after changes indicates your acceptance of the revised policy.
    </p>
    <h4>Contact Information</h4>
    <p>If you have any questions about this Privacy Policy, please contact us at: support@clascity.com</p>
  </section>
);

export default PrivacyPolicy;